import { useState, useRef, Fragment } from "react";
import Config from "../../Config";
import PlTitle from "../../elements/PlTitle";
import InputComboGrupa from "../../helpers/InputComboGrupa";
import InputTextAlpha from "../../helpers/InputTextAlpha";
import InputPagger from "../../helpers/InputPagger";
import FormatDecimal from "../../helpers/FormatDecimal";
import InputComboSubkonto from "../../helpers/InputComboSubkonto";
import InputDecimal from "../../helpers/InputDecimal";
import InputCombo from "../../helpers/InputCombo";

import edit from "../../edit.png";
import trash from "../../trash.png";
import restore from "../../restore.png";
import gopresent from "../../gopresent.png";
import InputText from "../../helpers/InputText";
import HtmlToPDF from "../../exporter/HtmlToPDF";
import Csv from "../../exporter/Csv";
import Print from "../../exporter/Print";

import TransferNew from "./TransferNew";
import TransferBank from "./TransferBank";

import CalculateEdit from "./CalculateEdit";
import SortBy from "../../helpers/SortBy";
import MenuTable from "../../helpers/MenuTable";

import search from "../../search.png";
import InputDate from "../../helpers/InputDate";
import AppContext from "../../AppContext";
import Xlsx from "../../exporter/Xlsx";
import FormatAccount from "../../helpers/FormatAccount";


function TransferOnline(props)
{

    const [refreshView, setRefreshView] = useState(props.userData.refreshView);


        
    const [filterParam, setFilterParam] = useState({
      
       
        d_imie_nazwisko: props.mainView.readFilter('d_imie_nazwisko',''), 
        r_imie_nazwisko: props.mainView.readFilter('r_imie_nazwisko',''), 
       

        kwota_od: '',
        kwota_do: '',

      

        data_od: '',
        data_do: '',


        tytul: '',

        sortBy: {
            sort:  "", //asc desc,
            column: "",
        },
     
        limit: 50,
        page: 1,
        pages: 1,
        show: true, 

    });
    const [tab, setTab] = useState(null);
    const [selectedRow, setSelectedRow] = useState([]);

    const tabRef = useRef(0); //do druku
    const tab2Ref = useRef(0); //do druku



    var defView =  {
        v:'list',
        id: -1
    } ;

    if(props.mainView.idSelected == -20) //wplata recnza
    {
        defView =  {
            v:'new',
            id: -1
        } ;
    }

    if(props.mainView.idSelected == -30) //wplata bank
    {
        defView =  {
            v:'bank',
            id: -1
        } ;
    }


    const [view, setView] = useState ( defView);


 


       
    const changeView = (e ) => {
        var v = e.target.getAttribute('v');
        var id = e.target.getAttribute('id');

        setView({...view, ["v"]:v, ["id"]:id });
}

    const onBack = (e) => {

        setView({...view, ["v"]:"list", ["id"]:"-1" }); 
        getTab();
        
    }



   
    const getTab = () => {
            
        
        props.mainView.setProgress(-2);
    

        fetch( Config.url + '/rest_v1_calc,transfer_online', {
            method: 'POST', 
            body: JSON.stringify(filterParam), 
            headers: {
                'Content-Type': 'application/json',                    
                'X-Api-Key': props.userData.apiKey,
                '_p_przedszkole_id_': props.userData.p_przedszkole_id,
                '_p_dziecko_id_': props.userData.p_dziecko_id,
                '_sec_key_': Config.genXKey() ,
            }
        })
        .then(res => res.json() )
        .then(res => { 

                    props.mainView.setProgress(-1);        
                    if(res._sys_ == undefined)
                    {
                        props.mainView.showDialog( "Error", "No correct response from server" , "ok" , null);  
                    }else
                    if(res.status != undefined && res.status == 'ERROR'  && res.result != undefined )
                    {
                        props.mainView.showDialog( "Error", JSON.stringify(res.result) , "ok" , null);  
                    }else    
                    {
                        setTab(res.result);  

                        var newSelector = [];

                        res.result.forEach( (item) => {
                            newSelector.push({
                                id: item.id,
                                title: item.numer_umowy + " ("+item.imie + " " + item.nazwisko +")",
                                selected: 0,
                            });
                        } )

                        setSelectedRow(newSelector);

                        if(res.pages != undefined )setFilterParam( {...filterParam,   ['pages']: res.pages  } );             
                    }
        } )
        .catch(err => {          
                    props.mainView.showDialog( "Error", "I: " + err , "ok" , null);
                    props.mainView.setProgress(-1);
        });
                

        return false;
    }




    const valChangeListener = (filedName, val, correct, msg) => {

        // console.log("valChangeListener: " + filedName + " " + val + ", correct: " + correct + ", msg: " + msg);

        setFilterParam( {...filterParam, [filedName]:val,  [filedName+"_valid"]:correct } );
        
        if(   (val.length == 0 || val.length > 2 || msg =='combo')  && filterParam[filedName] != val )
            {
                    var defTimeOut = 1000;
                    if(msg == 'combo') defTimeOut = 10;
                    clearTimeout(AppContext.timeoutId);
                    AppContext.timeoutId = setTimeout( () => {
                        setTab(null); 
                    } , defTimeOut );
            }

        props.mainView.writeFilter(filedName, val);
    }


    const goNextNew = () => {
        console.log("goNext");    
        setTab(null);    
    }


    const filterView = () => {
        setFilterParam(  {...filterParam, ["show"]:!filterParam.show } );
    }


    const filterClear = () => {

       
        props.mainView.writeFilter('p_group_id', '_x_'); 

        props.mainView.writeFilter('d_imie_nazwisko', ''); 
        props.mainView.writeFilter('r_imie_nazwisko', ''); 
 
   

        setFilterParam({
            d_imie_nazwisko: '', 
            r_imie_nazwisko: '', 
                        
              
            
      
            
            kwota_od: '',
            kwota_do: '',

            data_od: '',
            data_do: '',
            

      

            tytul: '',            

         
            
            
            sortBy: {
                sort:  "", //asc desc,
                column: "",
            },

            limit: 50,
            page: 1,
            show: true, 
        });
        setTab(null);
    }

    const filterApprove = () => {   
        setTab(null)     
    }

    const onChangePagger = (x_limit, x_page) => {

        setFilterParam(  {...filterParam, ["limit"]:x_limit, ["page"]:x_page} );
        setTab(null);
    }

    const onChangeSortBy = (sortBy) => {

        setFilterParam(  {...filterParam, ["sortBy"]:sortBy } );
        setTab(null);
    }



    const searchParent = (e) => {

        var search = e.target.getAttribute("search");
        //alert(search);

        setFilterParam( {...filterParam, ["r_imie_nazwisko"]:search,  ["r_imie_nazwisko_valid"]:true } );
        setTab(null);
    }

    const searchKid = (e) => {

        var search = e.target.getAttribute("search");
        //alert(search);

        setFilterParam( {...filterParam, ["d_imie_nazwisko"]:search,  ["d_imie_nazwisko_valid"]:true } );
        setTab(null);
    }





    const reviewKid = (e) =>
        {
            var id        = e.target.getAttribute("id");
            var imie      = e.target.getAttribute("imie");
            var nazwisko  = e.target.getAttribute("nazwisko");
    
            props.mainView.openKid( id, imie, nazwisko );
        }

        




    if(tab == null)
    {
        setTab([]);
        getTab();
    

        return <div>
            ...
        </div>
    }


    if(refreshView != props.userData.refreshView)
    {         
        setRefreshView( props.userData.refreshView);
        setTab(null);
        setView( {
            v:'list',
            id: -1
        });
    }



  

 
    


    const itemsAt = [
        { v: '_x_', title: '- - -' },
        { v: '0', title: 'Nie, ukryj' },               
        { v: '2', title: 'Tylko przelewy onLine' },         
    ]; 


    const itemsTakNie = [
        { v: '_x_', title: '- - -' },
        { v: '0', title: 'Nie' },               
        { v: '1', title: 'Tak' },         
    ]; 





    var sortList = [                
        {column: "kwota", name: "Kwota"  },
        {column: "data", name: "Data"  },
]


    
 


    return <div className="view_content">
          

            {
                    filterParam.show == false  &&
                    <div className="  goright link_color" onClick={filterView}>
                        pokaż filtry
                    </div>
            } 


            {
                    filterParam.show == true  &&
                                    <div className="table_filter">

                                    
                                                
                                   

                                    <div className="filter_controll">   
                                                <label>Rodzic: </label>                             
                                                <InputTextAlpha   userData={props.userData} value={filterParam.r_imie_nazwisko}   valChange={valChangeListener} goNext={goNextNew} name="r_imie_nazwisko" placeholder={"Rodzic: "}   />
                                    </div> 



                
                                    <div className="filter_controll">   
                                                <label>Tytuł (fraza): </label>                             
                                                <InputText   userData={props.userData} value={filterParam.tytul}   valChange={valChangeListener} goNext={goNextNew} name="tytul" placeholder={"Imię: "}   />
                                    </div> 

 


                                    <div className="filter_controll filter_merge">   
                                        <label>Kwota (od / do): </label>        
                                        <br/>                     
                                        <InputDecimal   userData={props.userData}  mainView={props.mainView}  value={filterParam.kwota_od}   valChange={valChangeListener} goNext={goNextNew} name="kwota_od" placeholder={" "}   />
                                        <InputDecimal   userData={props.userData}  mainView={props.mainView}  value={filterParam.kwota_do}   valChange={valChangeListener} goNext={goNextNew} name="kwota_do" placeholder={" "}   />
                                    </div> 


                                 


                                <div className="filter_controll filter_merge">   
                                    <label>Data (od dnia / do dnia): </label>      <br/>                       
                                    <InputDate   userData={props.userData} value={filterParam.data_od}   valChange={valChangeListener} goNext={goNextNew} name="data_od" placeholder={"Od dnia: "}   />                                                                  
                                    <InputDate   userData={props.userData} value={filterParam.data_do}   valChange={valChangeListener} goNext={goNextNew} name="data_do" placeholder={"Do dnia: "}   />
                                </div>


                                    <div className="filter_btn">
                                        <span className="link_color" onClick={filterView}>&nbsp;ukryj filtry&nbsp;</span> 
                                        <span className="btn" onClick={filterApprove} >filtruj</span>&nbsp;&nbsp;<span className="btn" onClick={filterClear} >wyczyść</span>
                                    </div>
                </div>
            } 

          


            <div className="bg_center">


                    <div className="table_widget">
                          
                

                            <InputPagger filter={filterParam}  onChange={onChangePagger}  />
                     
                                
              

                            &nbsp; &nbsp;
                                    <HtmlToPDF tabRef={tabRef} userData={props.userData} mainView={props.mainView}  orientation="landscape" title="Przelewy OnLine" />   
                                    <Csv tabRef={tab2Ref} title="Przelewy OnLine.csv" />                  
                                    <Xlsx tabRef={tab2Ref} title="Przelewy OnLine.xlsx" />                  
                                    <Print tabRef={tab2Ref} />

                            <SortBy  cols={sortList} param={filterParam.sortBy}  onChange={onChangeSortBy}  />        

                    </div>


                 


                    <div className="gohide" ref={tabRef}>

                                <h3>Przelewy OnLine</h3>   

                                <table className="table" ref={tab2Ref}>
                                <thead>
                                            <tr className="header">                                                                                   
                                                <td className="td_left">LP</td>                                                                                                                                                                                                                      
                                                <td >Data</td>                                                                                                                                                                                                                      
                                                <td >Rodzic</td>                                                                                                                                                                                                                      
                                                <td >Status</td>                                                                                                                                                                                                                      
                                                <td >ID Płatności</td>                                                                                                                                                                                                                      
                                                <td >Kanał płatności</td>                                                                                                                                                                                                                      
                                                <td className="td_right" >Zawartość koszyka</td>                                                                                                                                                                                                                      
                                                                                                                                                                                 
                                            </tr>
                                        </thead>
                                        <tbody>

                                        {
                                                tab.map(  (row, ix) => {
 

                                                        var css = " ";                                                                                                       
 

                                                        var rowStyle = " row ";
                                                        if(ix % 2 == 0 )rowStyle = " row2 ";


                                                        return <tr className={ rowStyle + css } key={ix}>                                                                                                 
                                                        <td className="gocenter">{ix + 1}</td>                                                 
                                                        <td className="gocenter">{row.payment_date}</td>                                                 
                                                        <td className="goleft">{row.rodzic.nazwisko + " " + row.rodzic.imie}</td>                                                 
                                                        <td className="goleft">{row.payment_status}</td>                                                 
                                                        <td className="gocenter">{row.order_id}</td>                                                 
                                                        <td className="gocenter">{row.pay_from}</td>                                                 
                                                        <td className="goleft">
                                                            <ul>
                                                                {
                                                                    row.koszyk.map( (pp, ixnPP) => {
                                                                        return <li key={ixnPP}>
                                                                           <FormatDecimal value={pp.amount} /> zł,<br/>
                                                                           {pp.product_name},<br/>
                                                                           <FormatAccount value={pp.customer_nrb} />                                                                    
                                                                        </li>
                                                                    } )
                                                                }
                                                            </ul>
                                                        </td>                                                                                                                                                    
                                                       

                                                       
                                                    </tr>

                                                })
                                        }
 

                                        </tbody> 
                              </table>
                    </div>

                <div className="scorll_x">
                    <table className="table" >
                                        <thead>
                                            <tr className="header">                                                                                   
                                                <td className="td_left">LP</td>                                                                                                                                                                                                                      
                                                <td >Data</td>                                                                                                                                                                                                                      
                                                <td >Rodzic</td>                                                                                                                                                                                                                      
                                                <td >Status</td>                                                                                                                                                                                                                      
                                                <td >ID Płatności</td>                                                                                                                                                                                                                      
                                                <td >Kanał płatności</td>                                                                                                                                                                                                                      
                                                <td className="td_right" >Zawartość koszyka</td>                                                                                                                                                                                                                      
                                                                                                                                                                                 
                                            </tr>
                                        </thead>
                                        <tbody>

                                        {
                                                tab.map(  (row, ix) => {
 

                                                        var css = " ";                                                                                                       
 

                                                        var rowStyle = " row ";
                                                        if(ix % 2 == 0 )rowStyle = " row2 ";


                                                        return <tr className={ rowStyle + css } key={ix}>                                                                                                 
                                                        <td className="gocenter">{ix + 1}</td>                                                 
                                                        <td className="gocenter">{row.payment_date}</td>                                                 
                                                        <td className="goleft">{row.rodzic.nazwisko + " " + row.rodzic.imie}</td>                                                 
                                                        <td className="goleft">{row.payment_status}</td>                                                 
                                                        <td className="gocenter">{row.order_id}</td>                                                 
                                                        <td className="gocenter">{row.pay_from}</td>                                                 
                                                        <td className="goleft">
                                                            <ul>
                                                                {
                                                                    row.koszyk.map( (pp, ixnPP) => {
                                                                        return <li key={ixnPP}>
                                                                           <FormatDecimal value={pp.amount} /> zł,<br/>
                                                                           {pp.product_name},<br/>
                                                                           <FormatAccount value={pp.customer_nrb} />                                                                    
                                                                        </li>
                                                                    } )
                                                                }
                                                            </ul>
                                                        </td>                                                                                                                                                    
                                                       

                                                       
                                                    </tr>

                                                })
                                        }
 

                                        </tbody>
                    </table>
                </div>

            </div>


    </div>
}


export default TransferOnline;